import React from "react";
import { separateNumber } from "utils/helpers";

interface HomeItemProps {
  title: string;
  owner: string | null;
  imgSrc: string;
  isAvailable: boolean;
  price?: number;
  onBuyClick: () => void;
}

const HomeItem: React.FC<HomeItemProps> = ({
  title,
  owner,
  imgSrc,
  isAvailable,
  price,
  onBuyClick,
}) => {
  return (
    <div className="home__item">
      <h3 className="home__title">{title}</h3>
      <img src={imgSrc} className="home__img" alt={title} />
      <h3 className="home__owner">{owner === null ? "Свободен" : `Владалец - ${owner}`}</h3>
      {isAvailable ? (
        <button className="home__button__available" onClick={onBuyClick}>
          {separateNumber(price!)} старок
        </button>
      ) : (
        <button className="home__button" disabled>
          Занят
        </button>
      )}
    </div>
  );
};

export default HomeItem;
